import { FC, ReactNode } from 'react'
import { SideoverState } from '@/states'
import { XMarkIcon } from '@heroicons/react/16/solid'
import { COMPONENT_DEFAULT_ERRORS, COMPONENT_DEFAULT_FORM } from '@/data'

const Header: FC = (): ReactNode => {
    const { SetState, Mode, Target } = SideoverState()

    const HandleClose = () => {
        if (Mode === 'edit') SetState({
            Open: false,
            Loading: false,
            Mode: 'create',
            Form: COMPONENT_DEFAULT_FORM,
            Errors: COMPONENT_DEFAULT_ERRORS
        })

        else SetState({ Open: false })
    }

    const HandleTitle = () => {
        if (Target === 'component') return Mode === 'edit' ? 'Edit Component' : 'Add Component'
        if (Target === 'tag') return Mode === 'edit' ? 'Edit Tag' : 'Add Tag'
        if (Target === 'category') return Mode === 'edit' ? 'Edit Category' : 'Add Category'
    }

    return (
        <div className='select-none px-4 py-[10.5px] flex justify-between border-b border-[#424242]'>
            <h1 className='mr-3 text-xl text-[#EBEBEB] font-semibold'>
                {HandleTitle()}
            </h1>

            <div onClick={HandleClose} className='bg-[#404040] w-6 h-6 rounded-md flex justify-center items-center hover:opacity-75 transition-all ease-in-out duration-500 cursor-pointer'>
                <XMarkIcon className='flex-shrink-0 w-5 h-5 text-[#EBEBEB]' />
            </div>
        </div>
    )
}

export default Header
